(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[21],{

/***/ "0jNN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),

/***/ "Mqll":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "QSc6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("0jNN");
var formats = __webpack_require__("sxOR");
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    formatter,
    encodeValuesOnly,
    charset
) {
    var obj = object;
    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        }).join(',');
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key') : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key');
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value'))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];
        var value = obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix
            : prefix + (allowDots ? '.' + key : '[' + key + ']');

        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            formatter,
            encodeValuesOnly,
            charset
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && opts.encoder !== undefined && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.formatter,
            options.encodeValuesOnly,
            options.charset
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ "Qyje":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__("QSc6");
var parse = __webpack_require__("nmq7");
var formats = __webpack_require__("sxOR");

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ "XbOJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_TEMPLATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return INIT_EDITOR_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return MOVE_SNIPPET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DUPLICATE_SNIPPET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return REMOVE_SNIPPET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return SET_EDITING_SNIPPET_ROW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return SET_EDITING_SNIPPET_COLUMN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return MOVE_COLUMN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return REMOVE_EDITING_SNIPPET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return EDIT_COLUMN_CONTENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_COLUMN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return EXPAND_COLUMN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return NARROW_COLUMN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return REMOVE_COLUMN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DUPLICATE_COLUMN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return SET_FAKE_TEMPLATE_ROW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return REMOVE_FAKE_TEMPLATE_ROW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return SET_THEME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return SET_STYLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return SET_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return SET_ROW_BACKGROUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CLEAR_EDITOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return SAVE_EDITOR_HISTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return EDITOR_UNDO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return EDITOR_REDO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FETCH_CURRENT_EDITING_DOCUMENT_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return FETCH_CURRENT_EDITING_DOCUMENT_SUCCESS; });
/* unused harmony export FETCH_CURRENT_EDITING_DOCUMENT_FAILED */
/* unused harmony export FETCH_CURRENT_EDITING_DOCUMENT_COMPLETED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return FETCH_EDITING_DOCUMENT_HISTORY_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return FETCH_EDITING_DOCUMENT_HISTORY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return FETCH_EDITING_DOCUMENT_HISTORY_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return ROLLBACK_DOCUMENT_VERSION_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return ROLLBACK_DOCUMENT_VERSION_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return ROLLBACK_DOCUMENT_VERSION_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AUTO_SAVE_DRAFT_REQUESTED; });
/* unused harmony export AUTO_SAVE_DRAFT_SUCCESS */
/* unused harmony export AUTO_SAVE_DRAFT_FAILED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return UPDATE_DOCUMENT_STYLE_CONFIG_REQUESTED; });
/* unused harmony export UPDATE_DOCUMENT_STYLE_CONFIG_SUCCESS */
/* unused harmony export UPDATE_DOCUMENT_STYLE_CONFIG_FAILED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DOWNLOAD_PDF_REQUESTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DOWNLOAD_PDF_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DOWNLOAD_PDF_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return addTemplate; });
/* unused harmony export initEditorView */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fb", function() { return moveSnippet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return duplicateSnippet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "kb", function() { return removeSnippet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pb", function() { return setEditingSnippetRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ob", function() { return setEditingSnippetColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "eb", function() { return moveColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ib", function() { return removeEditingSnippet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return editColumnContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return addColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return expandColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "gb", function() { return narrowColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hb", function() { return removeColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return duplicateColumn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "qb", function() { return setFakeTemplateRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jb", function() { return removeFakeTemplateRow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tb", function() { return setTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sb", function() { return setStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nb", function() { return setConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rb", function() { return setRowBackground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return clearEditor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mb", function() { return saveEditorHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return editorUndo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return editorRedo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return fetchCurrentEditingDocument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bb", function() { return fetchCurrentEditingDocumentSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ab", function() { return fetchCurrentEditingDocumentFailed; });
/* unused harmony export fetchCurrentEditingDocumentCompleted */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cb", function() { return fetchEditingDocumentHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "db", function() { return fetchEditingDocumentHistorySuccess; });
/* unused harmony export fetchEditingDocumentHistoryFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lb", function() { return rollbackDocumentVersion; });
/* unused harmony export rollbackDocumentVersionSuccess */
/* unused harmony export rollbackDocumentVersionFailed */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return autoSaveDraft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return autoSaveDraftSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return autoSaveDraftFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ub", function() { return updateDocumentStyleConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wb", function() { return updateDocumentStyleConfigSuccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "vb", function() { return updateDocumentStyleConfigFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return downloadPdf; });
/* unused harmony export downloadPdfSuccess */
/* unused harmony export downloadPdfFailed */
var ADD_TEMPLATE = 'editor/ADD_TEMPLATE';
var INIT_EDITOR_VIEW = 'editor/INIT_EDITOR_VIEW';
var MOVE_SNIPPET = 'editor/MOVE_SNIPPET';
var DUPLICATE_SNIPPET = 'editor/DUPLICATE_SNIPPET';
var REMOVE_SNIPPET = 'editor/REMOVE_SNIPPET';
var SET_EDITING_SNIPPET_ROW = 'editor/SET_EDITING_SNIPPET_ROW';
var SET_EDITING_SNIPPET_COLUMN = 'editor/SET_EDITING_SNIPPET_COLUMN';
var MOVE_COLUMN = 'editor/MOVE_COLUMN';
var REMOVE_EDITING_SNIPPET = 'editor/REMOVE_EDITING_SNIPPET';
var EDIT_COLUMN_CONTENT = 'editor/EDIT_COLUMN_CONTENT';
var ADD_COLUMN = 'editor/ADD_COLUMN';
var EXPAND_COLUMN = 'editor/EXPAND_COLUMN';
var NARROW_COLUMN = 'editor/NARROW_COLUMN';
var REMOVE_COLUMN = 'editor/REMOVE_COLUMN';
var DUPLICATE_COLUMN = 'editor/DUPLICATE_COLUMN';
var SET_FAKE_TEMPLATE_ROW = 'editor/SET_FAKE_TEMPLATE_ROW';
var REMOVE_FAKE_TEMPLATE_ROW = 'editor/REMOVE_FAKE_TEMPLATE_ROW';
var SET_THEME = 'editor/SET_THEME';
var SET_STYLE = 'editor/SET_STYLE';
var SET_CONFIG = 'editor/SET_CONFIG';
var SET_ROW_BACKGROUND = 'editor/SET_ROW_BACKGROUND';
var CLEAR_EDITOR = 'editor/CLEAR_EDITOR';
var SAVE_EDITOR_HISTORY = 'editor/SAVE_EDITOR_HISTORY';
var EDITOR_UNDO = 'editor/EDITOR_UNDO';
var EDITOR_REDO = 'editor/EDITOR_REDO';
var FETCH_CURRENT_EDITING_DOCUMENT_REQUESTED = 'editor/FETCH_CURRENT_EDITING_DOCUMENT_REQUESTED';
var FETCH_CURRENT_EDITING_DOCUMENT_SUCCESS = 'editor/FETCH_CURRENT_EDITING_DOCUMENT_SUCCESS';
var FETCH_CURRENT_EDITING_DOCUMENT_FAILED = 'editor/FETCH_CURRENT_EDITING_DOCUMENT_FAILED';
var FETCH_CURRENT_EDITING_DOCUMENT_COMPLETED = 'editor/FETCH_CURRENT_EDITING_DOCUMENT_COMPLETED';
var FETCH_EDITING_DOCUMENT_HISTORY_REQUESTED = 'editor/FETCH_EDITING_DOCUMENT_HISTORY_REQUESTED';
var FETCH_EDITING_DOCUMENT_HISTORY_SUCCESS = 'editor/FETCH_EDITING_DOCUMENT_HISTORY_SUCCESS';
var FETCH_EDITING_DOCUMENT_HISTORY_FAILED = 'editor/FETCH_EDITING_DOCUMENT_HISTORY_FAILED';
var ROLLBACK_DOCUMENT_VERSION_REQUESTED = 'editor/ROLLBACK_DOCUMENT_VERSION_REQUESTED';
var ROLLBACK_DOCUMENT_VERSION_SUCCESS = 'editor/ROLLBACK_DOCUMENT_VERSION_SUCCESS';
var ROLLBACK_DOCUMENT_VERSION_FAILED = 'editor/ROLLBACK_DOCUMENT_VERSION_FAILED';
var AUTO_SAVE_DRAFT_REQUESTED = 'editor/AUTO_SAVE_DRAFT_REQUESTED';
var AUTO_SAVE_DRAFT_SUCCESS = 'editor/AUTO_SAVE_DRAFT_SUCCESS';
var AUTO_SAVE_DRAFT_FAILED = 'editor/AUTO_SAVE_DRAFT_FAILED';
var UPDATE_DOCUMENT_STYLE_CONFIG_REQUESTED = 'editor/UPDATE_DOCUMENT_STYLE_CONFIG_REQUESTED';
var UPDATE_DOCUMENT_STYLE_CONFIG_SUCCESS = 'editor/UPDATE_DOCUMENT_STYLE_CONFIG_SUCCESS';
var UPDATE_DOCUMENT_STYLE_CONFIG_FAILED = 'editor/UPDATE_DOCUMENT_STYLE_CONFIG_FAILED';
var DOWNLOAD_PDF_REQUESTED = 'editor/DOWNLOAD_PDF_REQUESTED';
var DOWNLOAD_PDF_SUCCESS = 'editor/DOWNLOAD_PDF_SUCCESS';
var DOWNLOAD_PDF_FAILED = 'editor/DOWNLOAD_PDF_FAILED';

function addTemplate(_ref) {
  var templateId = _ref.templateId,
      targetIndex = _ref.targetIndex,
      templatesData = _ref.templatesData;
  return {
    type: ADD_TEMPLATE,
    templateId: templateId,
    targetIndex: targetIndex,
    templatesData: templatesData
  };
}

function initEditorView(_ref2) {
  var templateSetId = _ref2.templateSetId,
      templatesData = _ref2.templatesData,
      path = _ref2.path,
      title = _ref2.title;
  return {
    type: INIT_EDITOR_VIEW,
    templateSetId: templateSetId,
    templatesData: templatesData,
    path: path,
    title: title
  };
}

function moveSnippet(_ref3) {
  var fromIndex = _ref3.fromIndex,
      toIndex = _ref3.toIndex;
  return {
    type: MOVE_SNIPPET,
    fromIndex: fromIndex,
    toIndex: toIndex
  };
}

function duplicateSnippet(_ref4) {
  var uuid = _ref4.uuid,
      targetIndex = _ref4.targetIndex;
  return {
    type: DUPLICATE_SNIPPET,
    uuid: uuid,
    targetIndex: targetIndex
  };
}

function removeSnippet(uuid) {
  return {
    type: REMOVE_SNIPPET,
    uuid: uuid
  };
}

function setEditingSnippetRow(_ref5) {
  var rowUuid = _ref5.rowUuid;
  return {
    type: SET_EDITING_SNIPPET_ROW,
    rowUuid: rowUuid
  };
}

function setEditingSnippetColumn(_ref6) {
  var rowUuid = _ref6.rowUuid,
      colUuid = _ref6.colUuid;
  return {
    type: SET_EDITING_SNIPPET_COLUMN,
    rowUuid: rowUuid,
    colUuid: colUuid
  };
}

function moveColumn(_ref7) {
  var rowUuid = _ref7.rowUuid,
      fromIndex = _ref7.fromIndex,
      toIndex = _ref7.toIndex;
  return {
    type: MOVE_COLUMN,
    rowUuid: rowUuid,
    fromIndex: fromIndex,
    toIndex: toIndex
  };
}

function removeEditingSnippet() {
  return {
    type: REMOVE_EDITING_SNIPPET
  };
}

function editColumnContent(_ref8) {
  var rowUuid = _ref8.rowUuid,
      uuid = _ref8.uuid,
      html = _ref8.html;
  return {
    type: EDIT_COLUMN_CONTENT,
    rowUuid: rowUuid,
    uuid: uuid,
    html: html
  };
}

function addColumn(_ref9) {
  var rowUuid = _ref9.rowUuid,
      targetUuid = _ref9.targetUuid,
      direction = _ref9.direction;
  return {
    type: ADD_COLUMN,
    rowUuid: rowUuid,
    targetUuid: targetUuid,
    direction: direction
  };
}

function expandColumn(_ref10) {
  var rowUuid = _ref10.rowUuid,
      targetUuid = _ref10.targetUuid;
  return {
    type: EXPAND_COLUMN,
    rowUuid: rowUuid,
    targetUuid: targetUuid
  };
}

function narrowColumn(_ref11) {
  var rowUuid = _ref11.rowUuid,
      targetUuid = _ref11.targetUuid;
  return {
    type: NARROW_COLUMN,
    rowUuid: rowUuid,
    targetUuid: targetUuid
  };
}

function removeColumn(_ref12) {
  var rowUuid = _ref12.rowUuid,
      targetUuid = _ref12.targetUuid;
  return {
    type: REMOVE_COLUMN,
    rowUuid: rowUuid,
    targetUuid: targetUuid
  };
}

function duplicateColumn(_ref13) {
  var rowUuid = _ref13.rowUuid,
      targetUuid = _ref13.targetUuid;
  return {
    type: DUPLICATE_COLUMN,
    rowUuid: rowUuid,
    targetUuid: targetUuid
  };
}

function setFakeTemplateRow(targetIndex) {
  return {
    type: SET_FAKE_TEMPLATE_ROW,
    targetIndex: targetIndex
  };
}

function removeFakeTemplateRow() {
  return {
    type: REMOVE_FAKE_TEMPLATE_ROW
  };
}

function setTheme(theme) {
  return {
    type: SET_THEME,
    theme: theme
  };
}

function setStyle(style) {
  return {
    type: SET_STYLE,
    style: style
  };
}

function setConfig(_ref14) {
  var field = _ref14.field,
      value = _ref14.value;
  return {
    type: SET_CONFIG,
    field: field,
    value: value
  };
}

function setRowBackground(_ref15) {
  var uuid = _ref15.uuid,
      color = _ref15.color;
  return {
    type: SET_ROW_BACKGROUND,
    uuid: uuid,
    color: color
  };
}

function clearEditor() {
  return {
    type: CLEAR_EDITOR
  };
}

function saveEditorHistory(history) {
  return {
    type: SAVE_EDITOR_HISTORY,
    history: history
  };
}

function editorUndo() {
  return {
    type: EDITOR_UNDO
  };
}

function editorRedo() {
  return {
    type: EDITOR_REDO
  };
}

function fetchCurrentEditingDocument(_ref16) {
  var path = _ref16.path;
  return {
    type: FETCH_CURRENT_EDITING_DOCUMENT_REQUESTED,
    path: path
  };
}

function fetchCurrentEditingDocumentSuccess(_ref17) {
  var currentEditingDocument = _ref17.currentEditingDocument;
  return {
    type: FETCH_CURRENT_EDITING_DOCUMENT_SUCCESS,
    currentEditingDocument: currentEditingDocument
  };
}

function fetchCurrentEditingDocumentFailed() {
  return {
    type: FETCH_CURRENT_EDITING_DOCUMENT_FAILED
  };
}

function fetchCurrentEditingDocumentCompleted() {
  return {
    type: FETCH_CURRENT_EDITING_DOCUMENT_COMPLETED
  };
}

function fetchEditingDocumentHistory(path) {
  return {
    type: FETCH_EDITING_DOCUMENT_HISTORY_REQUESTED,
    path: path
  };
}

function fetchEditingDocumentHistorySuccess(_ref18) {
  var editingDocumentHistory = _ref18.editingDocumentHistory;
  return {
    type: FETCH_EDITING_DOCUMENT_HISTORY_SUCCESS,
    editingDocumentHistory: editingDocumentHistory
  };
}

function fetchEditingDocumentHistoryFailed() {
  return {
    type: FETCH_EDITING_DOCUMENT_HISTORY_FAILED
  };
}

function rollbackDocumentVersion(_ref19) {
  var path = _ref19.path,
      versionId = _ref19.versionId,
      onSuccess = _ref19.onSuccess;
  return {
    type: ROLLBACK_DOCUMENT_VERSION_REQUESTED,
    path: path,
    versionId: versionId,
    onSuccess: onSuccess
  };
}

function rollbackDocumentVersionSuccess() {
  return {
    type: ROLLBACK_DOCUMENT_VERSION_SUCCESS
  };
}

function rollbackDocumentVersionFailed() {
  return {
    type: ROLLBACK_DOCUMENT_VERSION_FAILED
  };
}

function autoSaveDraft(_ref20) {
  var path = _ref20.path,
      body = _ref20.body,
      body_json = _ref20.body_json;
  return {
    type: AUTO_SAVE_DRAFT_REQUESTED,
    path: path,
    body: body,
    body_json: body_json
  };
}

function autoSaveDraftSuccess() {
  return {
    type: AUTO_SAVE_DRAFT_SUCCESS
  };
}

function autoSaveDraftFailed() {
  return {
    type: AUTO_SAVE_DRAFT_FAILED
  };
}

function updateDocumentStyleConfig(_ref21) {
  var path = _ref21.path,
      theme = _ref21.theme,
      style = _ref21.style,
      config = _ref21.config,
      successMsg = _ref21.successMsg;
  return {
    type: UPDATE_DOCUMENT_STYLE_CONFIG_REQUESTED,
    path: path,
    theme: theme,
    style: style,
    config: config,
    successMsg: successMsg
  };
}

function updateDocumentStyleConfigSuccess() {
  return {
    type: UPDATE_DOCUMENT_STYLE_CONFIG_SUCCESS
  };
}

function updateDocumentStyleConfigFailed() {
  return {
    type: UPDATE_DOCUMENT_STYLE_CONFIG_FAILED
  };
}

function downloadPdf(_ref22) {
  var path = _ref22.path,
      isDraft = _ref22.isDraft,
      onSuccess = _ref22.onSuccess;
  return {
    type: DOWNLOAD_PDF_REQUESTED,
    path: path,
    isDraft: isDraft,
    onSuccess: onSuccess
  };
}

function downloadPdfSuccess() {
  return {
    type: DOWNLOAD_PDF_SUCCESS
  };
}

function downloadPdfFailed() {
  return {
    type: DOWNLOAD_PDF_FAILED
  };
}



/***/ }),

/***/ "nmq7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__("0jNN");

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
            val = utils.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj; // eslint-disable-line no-param-reassign
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    return utils.compact(obj);
};


/***/ }),

/***/ "sxOR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var util = __webpack_require__("0jNN");

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = util.assign(
    {
        'default': Format.RFC3986,
        formatters: {
            RFC1738: function (value) {
                return replace.call(value, percentTwenties, '+');
            },
            RFC3986: function (value) {
                return String(value);
            }
        }
    },
    Format
);


/***/ }),

/***/ "vsQu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("nKUr");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__("TSYQ");
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./node_modules/copy-to-clipboard/index.js
var copy_to_clipboard = __webpack_require__("+QRC");
var copy_to_clipboard_default = /*#__PURE__*/__webpack_require__.n(copy_to_clipboard);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("LvDl");

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__("Aiso");
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 24 modules
var es = __webpack_require__("/MKj");

// EXTERNAL MODULE: ./node_modules/redux/es/redux.js
var redux = __webpack_require__("ANjH");

// EXTERNAL MODULE: ./reducers/actions/globalAlert.js
var globalAlert = __webpack_require__("dDby");

// EXTERNAL MODULE: ./reducers/actions/editor.js
var editor = __webpack_require__("XbOJ");

// EXTERNAL MODULE: ./shapes/user.js
var user = __webpack_require__("xrJA");

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Modal.js + 19 modules
var Modal = __webpack_require__("zM5D");

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/OverlayTrigger.js + 3 modules
var OverlayTrigger = __webpack_require__("dDCJ");

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Tooltip.js
var Tooltip = __webpack_require__("AINe");

// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__("IP2g");

// EXTERNAL MODULE: ./node_modules/@fortawesome/fontawesome-svg-core/index.es.js
var fontawesome_svg_core_index_es = __webpack_require__("7O5W");

// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-regular-svg-icons/index.es.js
var pro_regular_svg_icons_index_es = __webpack_require__("uB96");

// EXTERNAL MODULE: ./node_modules/@fortawesome/free-brands-svg-icons/index.es.js
var free_brands_svg_icons_index_es = __webpack_require__("8tEE");

// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/index.es.js
var pro_solid_svg_icons_index_es = __webpack_require__("4Bjl");

// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__("Qyje");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./utils/url.js



function toQueryString(hash) {
  var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var stringifyQuery = lib_default.a.stringify(hash, {
    encode: encode
  });

  if (Object(lodash["isEmpty"])(stringifyQuery)) {
    return '';
  }

  return "?".concat(stringifyQuery);
}

function formatSocialShareUrl(_ref) {
  var platform = _ref.platform,
      url = _ref.url,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? 'Check out my @Slick!' : _ref$text;

  switch (platform) {
    case 'twitter':
      return "https://twitter.com/intent/tweet".concat(toQueryString({
        text: "".concat(text, " ").concat(url)
      }));

    case 'fb':
      return "https://www.facebook.com/sharer/sharer.php".concat(toQueryString({
        u: url
      }));

    case 'linkedin':
      return "https://www.linkedin.com/shareArticle".concat(toQueryString({
        url: url
      }));

    case 'email':
      return "mailto:?body=".concat(url);

    default:
      return "can't find this platform";
  }
}


// EXTERNAL MODULE: ./i18n.js
var i18n = __webpack_require__("k7Sn");

// CONCATENATED MODULE: ./public/images/Editor/document_html_to_pdf@2x.png
/* harmony default export */ var document_html_to_pdf_2x = ("data:image/png;base64,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");
// CONCATENATED MODULE: ./public/images/Editor/document_pdf@2x.png
/* harmony default export */ var document_pdf_2x = ("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFYAAABqCAMAAAARMFYTAAAAmVBMVEUAAAATrmkVsGoUr2kVr2oUrmoTrmoUr2oUr2kUsGoUsGkUsGoTsmwXsGsVv2ozzJkUrmkVr2wUr2oTrmn///+g3sM0uX5MwY1ZxpV1z6cktHTr+PP4/Prh9Oz8/v0bsG49vITz+/e15dCa3L+L17Z60atFv4kesnDk9u7R7+LE6tmq4smB1K9wzqUut3rX8eVjyZxdx5hRw5GJ/B1mAAAAE3RSTlMA/FfcU/Pj2aWainFCNwwF5kmCbFJGyAAAAghJREFUaN7t2WlvwjAMgGFYy7ExYJvD0TLacu++/v+PW5KCjGSBhWWkleX9FCB6hEKbRqJWdt8EUfWH2rGaIO3qGAvi6sdc0HaRrZ0curosutpsHV1N9gpdTbaGriqLriqLri6LLs/243ar0Wi14z7LosuycQTbophl0WXYG9jrhmepS1lU0eVY6lI29th1t9frXvthzLHUpRP6bl3vbssXt3duffs8iy6dgF/Wq971X5dhqUsntN0K4EduHdoMS106oWXHXfyoCwAthqUundCw4x5O7QFAg2epK2cP9SBZBJ6ti34y/hggu8DYQ4v8dqBRi7955Sy/1chZfmOUs3Qbl7P8Q0fO0gIb2AqwICywtou6EgIb2Cqy1doTqsVW60oI7L9lOxGcWNTh2Q4I6rBsJGEjBA7cvCAqsIiQKJsOXMuv3I6HbrhIRjm4isGuzens0JQ9jQBG2/F0DLax2ZWK2LckWT6ZSWrZLElWg6l9y7OzpCwXsalbi4l5t+wj2PKBydaOnQAmY2FuFp71PZsXJfbTrJB9N1nu2KEvl7Efm03xarIC2bV9E3+yHxlblgCy38akls2mvpGMnc1mz68F7LELM1VaW9hj15lZISu5eSmbF8tH8wKq7LZ5qs5mk/kYoGT/3A4WWDmr/0DXP36c57B0cSfGwAZ2n1Xs/GxTV23iP1+a6v0vCwYSsbwQEe4AAAAASUVORK5CYII=");
// EXTERNAL MODULE: ./components/Editor/Modal/PDFModal/index.scss
var Modal_PDFModal = __webpack_require__("Mqll");

// CONCATENATED MODULE: ./components/Editor/Modal/PDFModal/index.js



/* global Dropbox:false */





















fontawesome_svg_core_index_es["b" /* library */].add(pro_regular_svg_icons_index_es["s" /* faLink */], pro_regular_svg_icons_index_es["l" /* faDownload */], pro_regular_svg_icons_index_es["A" /* faTimes */], free_brands_svg_icons_index_es["d" /* faTwitter */], free_brands_svg_icons_index_es["b" /* faFacebookSquare */], free_brands_svg_icons_index_es["c" /* faLinkedin */], free_brands_svg_icons_index_es["a" /* faDropbox */], pro_solid_svg_icons_index_es["e" /* faEnvelope */], pro_solid_svg_icons_index_es["k" /* faPrint */]);

var PDFModal_PDFModal = function PDFModal(_ref) {
  var me = _ref.me,
      path = _ref.path,
      show = _ref.show,
      toggle = _ref.toggle,
      isDraft = _ref.isDraft,
      isSuccess = _ref.isSuccess,
      isFailed = _ref.isFailed,
      showGlobalAlert = _ref.showGlobalAlert,
      downloadPdf = _ref.downloadPdf,
      t = _ref.t;

  var _useState = Object(react["useState"])(''),
      pdf = _useState[0],
      setPdf = _useState[1];

  var downloadDocumentPdf = function downloadDocumentPdf() {
    downloadPdf({
      path: path,
      isDraft: isDraft,
      onSuccess: function onSuccess(p) {
        return setPdf(p);
      }
    });
  };

  Object(react["useEffect"])(function () {
    if (show) {
      downloadDocumentPdf();
    }
  }, [show]);

  var copyToClipBoard = function copyToClipBoard() {
    copy_to_clipboard_default()(pdf);
    showGlobalAlert({
      message: '[copied]',
      type: 'info'
    });
  };

  var shareToDropbox = function shareToDropbox(name) {
    return function () {
      Dropbox.save(pdf, "".concat(name, "_slick.pdf"));
    };
  };

  var barClass = classnames_default()('progress-bar', {
    'is-success': isSuccess,
    'is-failed': isFailed
  });
  var containerClass = classnames_default()('slide-container', {
    'is-success': isSuccess,
    'is-failed': isFailed
  });
  return /*#__PURE__*/Object(jsx_runtime["jsxs"])(Modal["a" /* default */], {
    show: show,
    className: "editor_modal_pdf-modal",
    children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
      className: barClass
    }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
      className: containerClass,
      children: [/*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
        className: "slide slide-1",
        children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(image_default.a, {
          src: document_html_to_pdf_2x,
          loading: "eager",
          alt: "document-html-to-pdf",
          width: 332,
          height: 178
        }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("h4", {
          children: [t('converting'), "..."]
        }), /*#__PURE__*/Object(jsx_runtime["jsx"])("p", {
          children: t('takeTimes')
        })]
      }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
        className: "slide slide-2",
        children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("h4", {
          children: t('pdfIsReady')
        }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
          className: "download-container",
          children: [/*#__PURE__*/Object(jsx_runtime["jsx"])(image_default.a, {
            src: document_pdf_2x,
            loading: "eager",
            alt: "document-pdf",
            width: 43,
            height: 53
          }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
            className: "info",
            children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("h5", {
              children: t('downloadNow')
            }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("p", {
              children: [me.first_name, ".pdf"]
            })]
          }), /*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
            className: "link",
            onClick: copyToClipBoard,
            children: /*#__PURE__*/Object(jsx_runtime["jsx"])(OverlayTrigger["a" /* default */], {
              placement: "top",
              overlay: /*#__PURE__*/Object(jsx_runtime["jsx"])(Tooltip["a" /* default */], {
                id: "copy-popover",
                children: t('copyToClipboard')
              }),
              children: /*#__PURE__*/Object(jsx_runtime["jsx"])(index_es["a" /* FontAwesomeIcon */], {
                icon: ['far', 'link']
              })
            })
          }), /*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
            className: "link",
            children: /*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
              href: pdf,
              children: /*#__PURE__*/Object(jsx_runtime["jsx"])(index_es["a" /* FontAwesomeIcon */], {
                icon: ['far', 'download']
              })
            })
          })]
        })]
      }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
        className: "slide slide-3",
        children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("h5", {
          children: t('orShare')
        }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
          className: "share-links",
          children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
            className: "share-link",
            children: /*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
              href: formatSocialShareUrl({
                platform: 'twitter',
                url: pdf
              }),
              rel: "noreferrer",
              target: "_blank",
              children: /*#__PURE__*/Object(jsx_runtime["jsx"])(index_es["a" /* FontAwesomeIcon */], {
                icon: ['fab', 'twitter']
              })
            })
          }), /*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
            className: "share-link",
            children: /*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
              href: formatSocialShareUrl({
                platform: 'fb',
                url: pdf
              }),
              rel: "noreferrer",
              target: "_blank",
              children: /*#__PURE__*/Object(jsx_runtime["jsx"])(index_es["a" /* FontAwesomeIcon */], {
                icon: ['fab', 'facebook-square']
              })
            })
          }), /*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
            className: "share-link",
            children: /*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
              href: formatSocialShareUrl({
                platform: 'linkedin',
                url: pdf
              }),
              rel: "noreferrer",
              target: "_blank",
              children: /*#__PURE__*/Object(jsx_runtime["jsx"])(index_es["a" /* FontAwesomeIcon */], {
                icon: ['fab', 'linkedin']
              })
            })
          }), /*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
            className: "share-link",
            onClick: shareToDropbox(me.first_name),
            children: /*#__PURE__*/Object(jsx_runtime["jsx"])(index_es["a" /* FontAwesomeIcon */], {
              icon: ['fab', 'dropbox']
            })
          }), /*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
            className: "share-link",
            children: /*#__PURE__*/Object(jsx_runtime["jsx"])("a", {
              href: formatSocialShareUrl({
                platform: 'email',
                url: pdf
              }),
              children: /*#__PURE__*/Object(jsx_runtime["jsx"])(index_es["a" /* FontAwesomeIcon */], {
                icon: "envelope"
              })
            })
          })]
        })]
      }), /*#__PURE__*/Object(jsx_runtime["jsxs"])("div", {
        className: "slide slide-failed",
        children: [/*#__PURE__*/Object(jsx_runtime["jsx"])("h4", {
          children: t('pdfFailed')
        }), /*#__PURE__*/Object(jsx_runtime["jsx"])("div", {
          className: "desc",
          children: /*#__PURE__*/Object(jsx_runtime["jsx"])(i18n["Trans"], {
            i18nKey: "editor:pdfFailedDesc",
            components: {
              brTag: /*#__PURE__*/Object(jsx_runtime["jsx"])("div", {}),
              preTag: /*#__PURE__*/Object(jsx_runtime["jsx"])("pre", {})
            }
          })
        })]
      })]
    }), /*#__PURE__*/Object(jsx_runtime["jsx"])("button", {
      className: "btn close-btn",
      type: "button",
      onClick: function onClick() {
        return toggle(false);
      },
      children: /*#__PURE__*/Object(jsx_runtime["jsx"])(index_es["a" /* FontAwesomeIcon */], {
        icon: ['far', 'times']
      })
    })]
  });
};

var PDFModal_mapStateToProps = function mapStateToProps(state) {
  var me = state.user.me,
      api = state.api;
  var isSuccess = Object(lodash["get"])(api, 'editor.DOWNLOAD_PDF.status') === 'success';
  var isFailed = Object(lodash["get"])(api, 'editor.DOWNLOAD_PDF.status') === 'failed';
  return {
    me: me,
    isSuccess: isSuccess,
    isFailed: isFailed
  };
};

var PDFModal_mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    showGlobalAlert: Object(redux["b" /* bindActionCreators */])(globalAlert["d" /* showGlobalAlert */], dispatch),
    downloadPdf: Object(redux["b" /* bindActionCreators */])(editor["S" /* downloadPdf */], dispatch)
  };
};

/* harmony default export */ var Editor_Modal_PDFModal = __webpack_exports__["a"] = (Object(i18n["withTranslation"])('editor')(Object(es["b" /* connect */])(PDFModal_mapStateToProps, PDFModal_mapDispatchToProps)( /*#__PURE__*/react_default.a.memo(PDFModal_PDFModal))));

/***/ })

}]);